import { useStore } from "@tanstack/react-form";
import React from "react";

import { useFieldContext } from "./formContext";

const getMessage = (error: unknown): string | undefined => {
  if (typeof error === "string") return error;
  if (typeof error === "object" && error !== null && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return undefined;
};

/**
 * Error line of the current field, markup `p.error-message`. It shows the
 * first error (one validator source) only once the field was blurred, or the form had a submit attempt and
 * the field is touched (a submit touches every mounted field; a field mounted after it, such as a new array
 * row, stays hidden until blur or change). Typing before any submit never reveals it. Pickers are not wired
 * to blur, so theirs appear after a submit attempt.
 */
export const FieldErrorMessage: React.FC = () => {
  const field = useFieldContext();
  const hasSubmitAttempt = useStore(field.form.store, (state) => state.submissionAttempts > 0);
  const { meta } = field.state;
  const message = getMessage(meta.errors[0]);

  if (!(meta.isBlurred || (hasSubmitAttempt && meta.isTouched)) || !message) return null;

  return (
    <p className="error-message" style={{ color: "#E3345E" }}>
      {message}
    </p>
  );
};
